import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ListFiltroCargasDescargas } from "../list";
import { ReporteCargaAdministradoresEdit, ReporteCargaAdministradores } from "./reporteCargaAdministrador";

interface Props {
    permisos: models.Rol;
}

class PantallaCargaDescargaNoRX extends React.PureComponent<Props> {
    onRegresar = () => {
        history.go("../");
    }

    render() {
        return (
            <div>
                <kea.Title titulo="Consulta de manifiestos de carga y descarga" onRegresar={this.onRegresar}>
                    {
                    }
                </kea.Title>

                <ListFiltroCargasDescargas cookieKey="filtrocargasdescargas" />
            </div>
        );
    }
}

const PantallaCargaDescargaRx = componentToRx(PantallaCargaDescargaNoRX);

export class PantallaCargaDescarga extends React.PureComponent {

    render() {
        return (
            <PantallaCargaDescargaRx permisos={resources.User.PermisoRx} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/pantalla/index.tsx